import { n, pct, TRACO } from '../format';

export interface BotaoLinha {
    id: string | number;
    label: string;
    /** Linha de baixo do rótulo: para onde o botão leva. */
    destino: string;
    tipo: 'link' | 'fluxo' | 'outro';
    cliques: number | null;
    unicos: number | null;
    ctr: number | null;
}

const V2 = 'precisa do rastreio por botão (V2)';

/** Botões DENTRO da mensagem (guia §4): nunca numa tabela à parte. */
export default function Botoes({ botoes }: { botoes: BotaoLinha[] }) {
    if (!botoes.length) return null;
    return (
        <div className="btns">
            {botoes.map(b => (
                <div className="btn-row" key={b.id}>
                    <span className="btn-ic">{b.tipo === 'link' ? '↗' : b.tipo === 'fluxo' ? '→' : '·'}</span>
                    <span className="btn-lb" title={b.label}>{b.label}<small title={b.destino}>{b.destino}</small></span>
                    <span className="v"><u>Cliques</u>{n(b.cliques)}</span>
                    <span className="v"><u>Únicos</u>{n(b.unicos)}</span>
                    <span className="v"><u>CTR</u><span style={{ color: 'var(--violet)' }}>{pct(b.ctr, 1)}</span></span>
                    <span className="v" title={V2}><u>Receita</u><span className="muted">{TRACO}</span></span>
                    <span className="v" title={V2}><u>RPC</u><span className="muted">{TRACO}</span></span>
                </div>
            ))}
        </div>
    );
}
